'use client'

import { useWindowSize } from '@/store/hooks'
import { JSX } from 'react'

type DivProps = JSX.IntrinsicElements['div']

interface ModalContainerProps extends DivProps {
    size?: 'lg' | 'md' | 'md2' | 'sm' | 'xs'
}

export const Container: React.FC<ModalContainerProps> = ({
    children,
    ...rest
}) => {
    let cName = rest.className

    delete rest.className

    const { width, size } = useWindowSize()

    if (size == 'sm' || size == 'xs') {
        cName += `   `
    }

    return (
        <div
            className={`w-full flex-1 flex-col ${cName ? cName : ''}`}
            {...rest}
        >
            {children}
        </div>
    )
}

export const Content: React.FC<DivProps> = ({ children, ...rest }) => {
    const cName = rest.className

    delete rest.className

    return (
        <div
            className={`w-full content flex flex-col flex-1 p-3 ${
                cName ? cName : ''
            }`}
            {...rest}
        >
            {children}
        </div>
    )
}

export const ModalContainer: React.FC<ModalContainerProps> = ({
    size = 'md',
    children,
    ...rest
}) => {
    let sizes = {
        lg: 'lg:!min-w-[90vw] lg:w-[90vw]',
        md: 'lg:!min-w-[800px] lg:w-[800px]',
        md2: 'lg:!min-w-[900px] lg:w-[900px]',
        sm: 'lg:!min-w-[700px] lg:w-[700px]',
        xs: 'lg:!min-w-[500px] lg:w-[500px]',
    }

    let cName = rest.className

    delete rest.className

    return (
        <div
            {...rest}
            className={`min-w-full w-full ${
                sizes[size]
            } mx-auto flex-1 flex-col modal-box !rounded-md ${
                cName ? cName : ''
            }`}
        >
            {children}
        </div>
    )
}

export const ModalActions: React.FC<ModalContainerProps> = ({
    children,
    ...rest
}) => {
    const cName = rest.className

    delete rest.className

    return (
        <div
            {...rest}
            className={`modal-action flex bg-white items-center sticky bottom-0 left-0 gap-3 ${
                cName ? cName : ''
            }`}
        >
            {children}
        </div>
    )
}
